import { isNullOrUndefined } from 'util';
import { Converter } from '../../converter.interface';
import { Injectable } from '@angular/core';
import { TaskProcessObject } from 'src/app/models/orders/order-details-process/process-details/process-task.model';

@Injectable({
    providedIn: 'root'
})
export class TaskProcessConverter implements Converter<TaskProcessObject>{

    public convert(input: any): TaskProcessObject {

        if (isNullOrUndefined(input)) { this.throwError(); }
        
        return new TaskProcessObject(input.idTask, input.formName, input.domain, input.operation, input.errorCode, input.errorDescription);
    }

    throwError(): TaskProcessObject {
        throw new Error("Data input is mandatory to load a characteristic");
    }
}
